import React from "react";
import { MapPin, Phone, Mail, BookOpen, Library, Smartphone, MapPinned } from "lucide-react";

export default function UtilityBar({ settings }) {
    if (!settings) return null;
    const items = [
        { label: "Student Portal", href: settings.portal_url, icon: BookOpen, id: "portal" },
        { label: "Library", href: settings.library_url, icon: Library, id: "library" },
        { label: "OPAC", href: settings.opac_url, icon: Library, id: "opac" },
        { label: "Mobile App", href: "/mobile-app", icon: Smartphone, id: "mobile-app", internal: true },
        {
            label: "Directions",
            href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(settings.map_query || "Lyceum Northern Luzon Urdaneta")}`,
            icon: MapPinned,
            id: "directions",
        },
    ];
    return (
        <div className="hidden md:block bg-lnl-green-deep text-white text-xs" data-testid="utility-bar">
            <div className="lnl-container flex items-center justify-between gap-4 h-9 flex-nowrap">
                <div className="flex items-center gap-5 opacity-95 min-w-0 flex-nowrap">
                    <span className="inline-flex items-center gap-1.5 truncate max-w-[46ch]">
                        <MapPin className="h-3.5 w-3.5 shrink-0" />
                        <span className="truncate">{settings.address_line}, {settings.province_line}</span>
                    </span>
                    <a href={`tel:${settings.mobile?.replace(/[^0-9+]/g, "")}`} className="util-link whitespace-nowrap" data-testid="utility-call">
                        <Phone className="h-3.5 w-3.5" /> {settings.mobile}
                    </a>
                    {settings.email_info && (
                        <a href={`mailto:${settings.email_info}`} className="util-link whitespace-nowrap hidden xl:inline-flex" data-testid="utility-email">
                            <Mail className="h-3.5 w-3.5" /> {settings.email_info}
                        </a>
                    )}
                </div>
                <div className="flex items-center gap-4 flex-nowrap">
                    {items.map(({ label, href, icon: Icon, id, internal }) => (
                        <a
                            key={id}
                            href={href}
                            target={internal ? undefined : "_blank"}
                            rel={internal ? undefined : "noopener noreferrer"}
                            className="util-link whitespace-nowrap"
                            data-testid={`utility-${id}`}
                            aria-label={internal ? label : `${label} (opens in a new tab)`}
                        >
                            <Icon className="h-3.5 w-3.5" /> {label}
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}
